export default __webpack_public_path__ + "static/media/hermess.0204bdd3.jpg";